import { render, staticRenderFns } from "./ViewBarItem.vue?vue&type=template&id=72c959a4&scoped=true&"
import script from "./ViewBarItem.vue?vue&type=script&lang=js&"
export * from "./ViewBarItem.vue?vue&type=script&lang=js&"
import style0 from "./ViewBarItem.vue?vue&type=style&index=0&id=72c959a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c959a4",
  null
  
)

export default component.exports